<!--
 * @Author: tianjingyuan 2297526156@qq.com
 * @Date: 2023-08-28 13:29:21
 * @LastEditors: tianjingyuan 2297526156@qq.com
 * @LastEditTime: 2023-08-29 16:27:50
 * @FilePath: /platform/src/views/system/noticeRules/components/riskStatusTable.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="image_content">
    <div class="risk_y">
      <span v-for="item in riskY" :key="item.label">{{ item.label }}</span>
    </div>
    <div
      class="back_image"
      :style="{ 'background-image': `url(${getImageUrl()})` }"
    >
      <div class="identifying">
        <div
          class="identifying_item"
          v-for="item in identifyingList"
          :key="item.color"
        >
          <div class="block" :style="{ background: item.color }"></div>
          <span>{{ item.label }}</span>
        </div>
      </div>
      <div class="numobj_content">
        <el-radio-group
          v-model="radioVal"
          @change="radioChangeC()"
          style="width: 100%"
        >
          <div v-for="row in yZhou" :key="row" class="numobj_content_item">
            <div
              v-for="column in xZhou"
              :key="column"
              class="numobj"
              :style="{ background: returnColor(row * column) }"
            >
              <el-radio
                v-if="isShowRadio(row * column)"
                :label="`${row}${column}${row * column}`"
                class="radio_css"
                >{{ "" }}</el-radio
              >
              {{ row * column }}
            </div>
          </div>
        </el-radio-group>
      </div>
    </div>
    <div class="risk_x">
      <span v-for="item in riskX" :key="item.label">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabActive: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      riskY: [
        {
          label: "极低-1"
        },
        {
          label: "低-2"
        },
        {
          label: "中-3"
        },
        {
          label: "高-4"
        },
        {
          label: "风险发生可能性"
        }
      ],
      riskX: [
        {
          label: "微小-1"
        },
        {
          label: "较小-2"
        },
        {
          label: "较大-3"
        },
        {
          label: "重大-4"
        },
        {
          label: "风险后果影响严重程度"
        }
      ],
      identifyingList: [
        {
          color: "#38b766",
          label: "一般风险(1-3)"
        },
        {
          color: "#ffa33f",
          label: "中等风险(4-6)"
        },
        {
          color: "#ff625a",
          label: "重大风险(7-16)"
        }
      ],
      xZhou: [1, 2, 3, 4],
      Zhou: [1, 2, 3, 4],
      yZhou: [],
      radioVal: ""
    };
  },
  created() {
    this.yZhou = this.Zhou.reverse();
  },
  methods: {
    initValue(val) {
      console.log(val);
      this.radioVal = val ? val : "";

      this.$forceUpdate();
    },
    getImageUrl() {
      return require(`@/assets/img/zbz.png`);
    },
    returnColor(colorNumber) {
      if (colorNumber) {
        if ([1, 2, 3].includes(colorNumber)) return "#38b766";
        if ([4, 6].includes(colorNumber)) return "#ffa33f";
        if ([8, 9, 12, 16].includes(colorNumber)) return "#ff625a";
      }
    },
    /**
     * @description:
     * @param {*} y y轴数据
     * @param {*} x x轴数据
     * @param {*} z 总计
     * @return {*}
     */
    radioChangeC() {
      let setNum = this.radioVal.split("");
      console.log(setNum);
      this.$emit(
        "radioChangeone",
        this.radioVal,
        setNum[0],
        setNum[1],
        setNum[3] ? setNum[2] + setNum[3] : setNum[2]
      );
    },
    isShowRadio(colorNumber) {
      if (this.tabActive) {
        if ([1, 2, 3].includes(colorNumber) && this.tabActive === "ybtx")
          return true;
        if ([4, 6].includes(colorNumber) && this.tabActive === "yjtx")
          return true;
        if ([8, 9, 12, 16].includes(colorNumber) && this.tabActive === "fxtx")
          return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.image_content {
  width: 600px;
  height: 300px;
  display: flex;
  flex-wrap: wrap;
  .risk_y {
    width: 80px;
    height: 260px;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    box-sizing: border-box;
    span {
      height: 20%;
      line-height: 20px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .back_image {
    width: 520px;
    height: 260px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .identifying {
      height: 15%;
      margin-left: 12px;
      display: flex;
      .identifying_item {
        width: 33%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          font-size: 14px;
        }
        .block {
          width: 20px;
          height: 20px;
          margin: 0 4px;
          background-color: red;
        }
      }
    }
    .numobj_content {
      width: 402px;
      margin-left: 12px;
      display: flex;
      flex-wrap: wrap;
      height: calc(100% - 20%);
      padding-top: 14px;
      box-sizing: border-box;
      .numobj_content_item {
        width: 100%;
        height: 25%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        .numobj {
          position: relative;
          width: 24%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          border: 0.5px solid #ffffff;
          .radio_css {
            position: absolute;
            left: 4px;
            top: 4px;
            z-index: 99999;
          }
        }
      }
    }
  }
  .risk_x {
    width: 520px;
    margin-left: 92px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      width: 20%;
      line-height: 20px;
      text-align: center;
    }
  }
}
// .el-radio {
//   /deep/.el-radio__inner {
//     width: 15px;
//     height: 15px;
//     border: 1px solid #ffffff;
//     &::after {
//       width: 16px;
//       height: 16px;
//       background: red;
//     }
//   }
// }
</style>